export enum ErrorForms {
  GenericError = 'Este campo es requerido',
  InvalidError = 'Este campo es inválido',
  InvalidEmail = 'El correo electrónico no es válido',
  InvalidPhone = '`El formato del número de teléfono no es válido, debes ingresarlo sin espacios, sin guiones o algún otro carácter especial.`',
  OptionError = 'Por favor ingrese un valor en al menos uno de los campos.',
  NumberError = 'Debe ser un numérico',
  TaxIdError = 'Debe comenzar con un número',
  SymbolsError = 'El texto solo puede contener letras y números',
  DpiError = 'El número de DPI debe tener 13 dígitos númericos',
}

export enum ErrorApis {
  //servicio+status
  Generic500 = 'Ocurrió un error, intente nuevamente',
  ErrorConnection = 'No se pudo establecer conexión con el servidor',
}
